import React from 'react';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

import { PaymentMethod } from '../helpers/paymentMethods';

export interface IPaymentMethodOption {
  method: PaymentMethod;
  label: string;
  icon: React.ComponentType;
}

export const PAYMENT_METHOD_OPTIONS: IPaymentMethodOption[] = [
  {
    method: 'credit_card',
    label: 'Cartão de crédito',
    icon: CreditCardOutlinedIcon,
  },
  {
    method: 'pix',
    label: 'Pagar com Pix',
    icon: QrCode2OutlinedIcon,
  },
  {
    method: 'boleto',
    label: 'Boleto bancário',
    icon: ReceiptLongOutlinedIcon,
  },
];
